'use client'

import { Image } from '@vinted/web-ui'

import { HoVLogoModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = {
  data: HoVLogoModel
}

const HoVLogo = ({ data: { logoUrl } }: Props) => (
  <section className="hov__logo">
    <Image src={logoUrl} scaling="cover" alt="House of Vinted" />
  </section>
)

export default HoVLogo
